import { render, staticRenderFns } from "./ModalInfoProdutoNew.vue?vue&type=template&id=93ccd788&scoped=true&"
import script from "./ModalInfoProdutoNew.vue?vue&type=script&lang=js&"
export * from "./ModalInfoProdutoNew.vue?vue&type=script&lang=js&"
import style0 from "./ModalInfoProdutoNew.vue?vue&type=style&index=0&id=93ccd788&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93ccd788",
  null
  
)

export default component.exports